import { Routes } from '@angular/router';
import { ThemeDemoComponent } from './components/theme-demo.component';
import { LoginComponent } from './pages/public/login/login.component';
import { ForgotPasswordComponent } from './pages/public/forgotten-passsword/forgot-password.component';
import { HomeComponent } from './pages/protected/home/home.component';
import { UsersComponent } from './pages/protected/users/users.component';
import { UserEditComponent } from './pages/protected/user-edit/user-edit.component';
import { ProjectsComponent } from './pages/protected/projects/projects.component';
import { ProjectEditComponent } from './pages/protected/project-edit/project-edit.component';
import { SuccessStoriesComponent } from './components/success-stories/success-stories.component';
import { LearnMoreComponent } from './components/learn-more/learn-more.component';
import { CommunityComponent } from './components/community/community.component';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { 
    path: '', 
    component: HomeComponent,
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'dashboard', component: ThemeDemoComponent },
      { path: 'users', component: UsersComponent },
      { path: 'users/:id', component: UserEditComponent },
      { path: 'projects', component: ProjectsComponent },
      { path: 'projects/:id', component: ProjectEditComponent },
      { path: 'success-stories', component: SuccessStoriesComponent },
      { path: 'learn-more', component: LearnMoreComponent },
      { path: 'community', component: CommunityComponent }
    ]
  },
  {
    path: '**',
    redirectTo: '/login'
  }
];
